import { useState } from 'react';
import { createRoot } from 'react-dom/client';

import ComponentHeader from "GeneralComponents/ComponentHeader";
import ComponentBackground from "GeneralComponents/ComponentBackground"

import { BackColor } from "Interfaces/general.interface";
import './Media.min.css';

function checkIsAllowedUrlForIframe(url: string, allowedDomains: string) {
    const youtubeRegex = /^(https?:\/\/(?:[a-zA-Z0-9-]+\.)?(youtube\.com|youtu\.be)\/(?:[^\/\n\s]+|(?:watch|embed|v|shorts|playlist|live)\/[^\/\n\s]+))$/;
    const govIlRegex = /^https?:\/\/(?:[a-zA-Z0-9-]+\.)*gov\.il\/.*$/;
    const isValidString = typeof url == 'string' && url.length >= 15;

    if (isValidString && govIlRegex.test(url) || youtubeRegex.test(url) || url.startsWith('/')) return true;

    const isValidDomain = (domain: string) => domain.trim().length >= 15 && url.startsWith(domain);
    const isIncludedDomain = allowedDomains && allowedDomains.split(',').some(isValidDomain);
    if (isIncludedDomain) return true;

    return false;
}

type Props = {
    componentId: string;
    disptitle: string;
    movieLink: string;
    movieLink2: string;
    bgimage: string;
    mobileBgImage: string;
    bgImgOpacity: string;
    backColor: string;
    mediaAllowedDomains: string;
}

const Media: React.FC<Props> = ({ bgimage, mediaAllowedDomains, bgImgOpacity, componentId, disptitle, mobileBgImage, movieLink, movieLink2, backColor }) => {

    const backGround: BackColor = backColor ? JSON.parse(backColor) : null;
    const safeMovieLink1 = checkIsAllowedUrlForIframe(movieLink, mediaAllowedDomains || '') ? movieLink : '';
    const safeMovieLink2 = checkIsAllowedUrlForIframe(movieLink2, mediaAllowedDomains || '') ? movieLink2 : '';
    const hasTwoMovieLinks = (safeMovieLink1 && safeMovieLink2);
    const containerClass = "container";
    const [lightBg, setLightBg] = useState(true);

    return (
        <ComponentBackground
            componentId={"Media-" + componentId}
            bgImage={bgimage}
            bgMobileImage={mobileBgImage}
            bgImgOpacity={bgImgOpacity}
            backGround={backGround}
            setLightBg={setLightBg}
            partialBg={true}
        >
            <div className='container'>
                <ComponentHeader disptitle={disptitle} dispdescription="" light={lightBg} />
            </div>
            <div className={`${containerClass} mst-block-component`}>
                {
                    hasTwoMovieLinks ?
                        <div className="mst-double-movie d-flex flex-column  flex-lg-row px-0">
                            <div className="ratio ratio-16x9 mr-0 ml-2 my-0 embed-responsive-item">
                                <iframe
                                    src={movieLink}
                                    allowFullScreen title={disptitle}
                                    loading="lazy"
                                    referrerPolicy="strict-origin-when-cross-origin">
                                </iframe>
                            </div>

                            <div className="ratio ratio-16x9 mr-2 ml-0 my-0 embed-responsive-item">
                                <iframe
                                    src={movieLink2}
                                    allowFullScreen
                                    title={disptitle}
                                    loading="lazy"
                                    referrerPolicy="strict-origin-when-cross-origin">
                                </iframe>
                            </div>
                        </div>
                        :
                        <div className="ratio ratio-16x9 embed-responsive-item">
                            <iframe
                                src={movieLink}
                                title={disptitle}
                                loading="lazy"
                                referrerPolicy="strict-origin-when-cross-origin">
                            </iframe>
                        </div>
                }
            </div>
        </ComponentBackground>
    );

}

var elements = document.querySelectorAll('[id^="Media-"]');


for (var i = 0; i < elements.length; i++) {

    var rootElement = document.getElementById(elements[i].id);
    var root = createRoot(rootElement);
    root.render(
        <Media
            componentId={rootElement.getAttribute('component-id')}
            disptitle={rootElement.getAttribute('component-title')}
            movieLink={rootElement.getAttribute('component-link')}
            movieLink2={rootElement.getAttribute('component-link2')}
            bgimage={rootElement.getAttribute('component-background')}
            mobileBgImage={rootElement.getAttribute('component-mobileBackground')}
            bgImgOpacity={rootElement.getAttribute('component-bgImgOpacity')}
            backColor={rootElement.getAttribute('component-backColor')}
            mediaAllowedDomains={rootElement.getAttribute('media-AllowedDomains')}

        />);

}



